/* 🤖 this file was generated by svg-to-ts */
export const matIconArrowRightAlt: {
  name: 'arrow-right-alt';
  data: string;
} = {
  name: 'arrow-right-alt',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M16.01 11H4v2h12.01v3L20 12l-3.99-4v3z"/></svg>`
};
